import campusRoutes from 'campus/routes';
import externalRoutes from './routes/external.routes';
import adminRoutes from './routes/admin.routes';
import miscRoutes from './routes/misc.routes';

const routes = [
    ...externalRoutes,
    ...adminRoutes,
    // Кампус — до miscRoutes: там объявлен catchAll админки, который иначе
    // перехватил бы все пути /campus/*.
    ...campusRoutes,
    ...miscRoutes,
];

export default routes;
